import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { SenhaService } from "../recuperar-senha/senha.service";
import { Location } from '@angular/common';

@Component({
  selector: 'app-alterar-senha',
  templateUrl: './alterar-senha.component.html',
  styleUrls: ['./alterar-senha.component.scss']
})
export class AlterarSenhaComponent implements OnInit {

  codigo!: string;
  form!: FormGroup;
  estudanteId: number;
  showSenhaAtual: boolean = false;
  showNovaSenha: boolean = false;
  showConfirmarSenha: boolean = false;

  origem!: string;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private senhaService: SenhaService,
    private toast: ToastrService,
    private router: Router,
    private location: Location

  ) { }

  ngOnInit(): void {
    //this.codigo = this.route.snapshot.paramMap.get('codigo') || '';

    this.route.queryParams.subscribe(params => {
      this.origem = params['origem'] || null;
    });

    this.form = this.fb.group(
      {
        senhaAtual: ['', [
          Validators.required,
          Validators.minLength(8),
          //Validators.pattern(/^(?=.*[A-Z])(?=.*\d)(?=.*[@#$&*!]).+$/)
        ]],

        novaSenha: ['', [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(/^(?=.*[A-Z])(?=.*\d)(?=.*[@#$&*!]).+$/)
        ]],
        confirmarSenha: ['', Validators.required]
      },
      {
        validators: [this.senhasIguaisValidator]
      }
    );
    this.estudanteId = Number(this.route.snapshot.paramMap.get("id"));
  }

  senhasIguaisValidator(group: AbstractControl): ValidationErrors | null {
    const senha = group.get('novaSenha')?.value;
    const confirmar = group.get('confirmarSenha')?.value;
    return senha === confirmar ? null : { senhasDiferentes: true };
  }

  senhaAtualDifereDaNova(group: AbstractControl): ValidationErrors | null {
    const senha = group.get('senhaAtual')?.value;
    const confirmar = group.get('novaSenha')?.value;
    return senha === confirmar ? null : { senhasDiferentes: true };
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const senhaAtual = this.form.value.senhaAtual;
    const novaSenha = this.form.value.novaSenha;

    this.senhaService.alterarSenhaInterno(/*this.codigo*/ senhaAtual, novaSenha).subscribe({
      next: () => {
        this.toast.success('Senha alterada com sucesso!')
        if (this.origem === 'menu') {
          this.router.navigate(['/home']);
        } else {
          this.redirectTo('complemento-cadastro-estudante/' + this.estudanteId);
        }
      },
      error: (err) => {
        const mensagem = Array.isArray(err.error) && err.error[0]?.message
          ? err.error[0].message
          : 'Erro ao alterar a senha.';
        this.toast.error(mensagem);
      }
    });
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate([uri]));
  }

  cancelar(): void {
    if (this.origem === 'menu') {
      this.router.navigate(['/home']);
    } else {
      this.redirectTo('login');
    }
  }

  togglePasswordVisibility(field: 'showSenhaAtual' | 'showNovaSenha' | 'showConfirmarSenha'): void {
    this[field] = !this[field];
  }

}
